import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useFeatureFlags, type FeatureFlag } from '@/state/useFeatureFlags';
import { FeatureFlagSettings } from './FeatureFlagSettings';
import { FeatureFlagDeployed } from './FeatureFlagDeployed';

export const FeatureFlagDetails = () => {
  const { id } = useParams();
  const { getFlag } = useFeatureFlags();
  const [flag, setFlag] = useState<FeatureFlag | null>(null);

  useEffect(() => {
    if (!id) return;
    getFlag(id).then(setFlag);
  }, [id]);

  if (!flag) return null;

  if (flag.status === 'deployed') {
    return <FeatureFlagDeployed flag={flag} />;
  }

  return <FeatureFlagSettings flag={flag} />;
};
